module.exports = __webpack_public_path__ + "img/347.37e54404.png";